import React from 'react';
import { Helmet } from 'react-helmet';
import { FaqData } from '../types';
type CIFaqProps = {
  data: FaqData[];
  pageUrl: string;
  visible?: boolean;
};
const CIFaq = ({ data, pageUrl, visible = true }: CIFaqProps) => {
  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {`
        {
        "@context": "http://schema.org",
        "@type": "FAQPage",
        "mainEntity": ${JSON.stringify(
          data.map((faq) => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: `${faq.answer.concat(`<a href=${pageUrl}>Book Now</a>`)}`
            }
          }))
        )}
        }
      `}
        </script>
      </Helmet>
      {visible && (
        <section className="faq__gery__bg">
          <div className="ins__main">
            <div className="faq__wrap appendBottom50">
              <p className="font20 bold dark-text appendBottom30">Frequently Asked Questions</p>
              <details className="font12 dark-text appendBottom15">
                <summary>What is Digit Group Illness Insurance?</summary>
                <p className="lineHeight20 appendTop10 markdown-body">
                  Digit Group Illness Insurance is an indemnity product, covering your hospitalization expenses incurred
                  due positive diagnosis of Coronavirus disease (COVID-19). Anyone between the age group of 18 to 60
                  years is eligible to buy the coronavirus (COVID-19) cover (you can also cover anyone in your family up
                  to the age of 60 years)
                </p>
              </details>
              <details className="font12 dark-text appendBottom15">
                <summary>What is the maximum Sum Insured that I can opt for under this policy?</summary>
                <p className="lineHeight20 appendTop10 markdown-body">
                  This policy has individual Sum Insured options up to INR 3 Lakhs which means that each individual
                  policy can have a maximum Sum Insured of INR 3 Lakhs.
                </p>
              </details>
              <details className="font12 dark-text appendBottom15">
                <summary>When can I make a claim?</summary>
                <p className="lineHeight20 appendTop10 markdown-body">
                  You can make a claim if you are diagnosed and tested positive for COVID-19 and hospitalized solely due
                  to COVID-19.
                </p>
              </details>
              <details className="font12 dark-text appendBottom15">
                <summary>Is this a Floater or Individual Policy?</summary>
                <p className="lineHeight20 appendTop10 markdown-body">This is an Individual Sum Insured policy.</p>
              </details>
              <details className="font12 dark-text appendBottom15">
                <summary>
                  Is it mandatory to have inpatient treatment at a hospital, for a claim to be admitted under the
                  policy?
                </summary>
                <p className="lineHeight20 appendTop10 markdown-body">
                  Yes, the policy is for inpatient treatment in any hospital (Government, Private – government
                  authorized, Military).
                </p>
              </details>
              <details className="font12 dark-text appendBottom15">
                <summary>If I get quarantined, will my policy cover the Hospitalization expenses incurred?</summary>
                <p className="lineHeight20 appendTop10 markdown-body">
                  Yes. Coverage for Quarantine in a hospital shall be payable only if it is later diagnosed that the
                  insured person was suffering from COVID-19 during the Quarantine.
                </p>
              </details>
              <details className="font12 dark-text appendBottom15">
                <summary>Is there any waiting period applicable in this policy?</summary>
                <p className="lineHeight20 appendTop10 markdown-body">
                  Yes. The Digit Group Illness Insurance has an initial waiting period of 15 days and shall be
                  applicable for anyone who avails of this policy.
                </p>
              </details>
              <details className="font12 dark-text appendBottom15">
                <summary>What are the other important exclusions in the policy that I should be aware of?</summary>
                <p className="lineHeight20 appendTop10 markdown-body" id="content1">
                  <p>Exclusions under the Digit Group Illness Insurance plan include: </p>
                  <ul>
                    <li>Hospitalisation expenses in case of texting negative Coronavirus disease (COVID-19) </li>
                    <li>
                      Charges towards treatment or quarantine for Coronavirus disease (COVID-19) before the policy
                      issuance will not be covered{' '}
                    </li>
                    <li>
                      <strong>Comorbidity exclusion clause -</strong> Insured Member(s) is/are not suffering from fever
                      or suffering /suffered from diabetes, hypertension, disease related to heart/lungs/kidney/liver,
                      cancer, stroke or any condition that needs ongoing medication or the insured members(s) is/are due
                      for any medical treatment, at the time of buying this policy{' '}
                    </li>
                    <li>Home hospitalisation (Domiciliary hospitalisation) expenses will not be covered </li>
                    <li>
                      Hospitalisation expenses for patients only under investigation with inconclusive medical report
                      will not be covered{' '}
                    </li>
                    <li>Treatment taken outside India will not be covered </li>
                    <li>
                      Test report for Coronavirus disease (COVID-19) conducted from centres other than Govt/ICMR
                      Authorized test Centre in India will not be considered
                    </li>
                  </ul>
                </p>
              </details>
              <details className="font12 dark-text appendBottom15">
                <summary>What is the process to reimburse already incurred expenses?</summary>
                <p className="lineHeight20 appendTop10 markdown-body" id="content2">
                  <p>Below steps to reimburse: </p>
                  <ul>
                    <li>
                      <strong>Intimation-</strong> Insured to call digit to register reimbursement claim{' '}
                    </li>
                    <li>
                      <strong>Document Upload-</strong> Insured to upload all relevant documents on digit website or
                      email them to <a href="mailto:healtclaims@godigit.com">healtclaims@godigit.com</a>{' '}
                    </li>
                    <li>
                      <strong>Settlement-</strong> Digit will verify the document and process the claim within 3 days.
                      The amount will be transferred to the insured{"'"}s bank account.
                    </li>
                  </ul>
                  `
                </p>
              </details>
              <details className="font12 dark-text appendBottom15">
                <summary>Is it cashless ? What is the process?</summary>
                <p className="lineHeight20 appendTop10 markdown-body" id="content3">
                  <p>Yes. The process is as below: </p>
                  <ul>
                    <li>
                      <strong>Intimation-</strong> Insured informs Digit about the hospital details and shares the
                      report from ICMR authorised about being corona +ve . Report to be emailed to{' '}
                      <a href="mailto:healthclaims@godigit.com">healthclaims@godigit.com</a> .{' '}
                    </li>
                    <li>
                      <strong>Approval-</strong> If eligible digit will inform the hospital for cashless approval{' '}
                    </li>
                    <li>
                      <strong>Settlement-</strong> Amount will be settled with the hospital directly
                    </li>
                  </ul>
                </p>
              </details>
            </div>
          </div>
        </section>
      )}
    </>
  );
};
export default CIFaq;
